import React, { useContext, useEffect, useState } from 'react';
import { ListGroup, Row, Col, Image, Modal, Button, Container, Card, Table } from 'react-bootstrap';
import { OrderContext } from '../../context/OrderContext';
import { useNavigate } from 'react-router-dom';
import useCreateRefund from '../../hook/useCreateRefund';





const InvoiceProduct = () => {


  const navigate = useNavigate();

  const [filteredProducts, setFilteredProducts] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);


  const {dataProducts} = useCreateRefund()


  const { orderProduct, orderNumber, email} = useContext(OrderContext);


  useEffect(() => {
    if (orderNumber && email) {
      dataProducts(orderNumber, email);
    }
  }, [orderNumber, email]);

  const map_product = orderProduct?.OrderProducts

  useEffect(() => {
    if (orderProduct) {
      

      const totalQuantity = map_product?.reduce((total, product) => total + product.Count, 0);
      const totalPrice = map_product.reduce((total, product) => total + (product.Count * 100), 0);

      setTotalProducts(totalQuantity);
      setTotalAmount(totalPrice);
    }
  }, [orderProduct]);


  


  const handleClick = () => {
   
    navigate("/invoice-summary")

  };

  function formatCurrency(amount) {
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(amount);
  }


  return (
    <>
  <Container className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
    
    {/* Ürün Listesi */}
    <Row className="w-100 justify-content-center">
          <Col md={6}>
            <ListGroup>
              {map_product?.map((product) => (
                <ListGroup.Item key={product.Id} className="product-card">
                  <Row className="g-1 align-items-center row_box">
                    <Col xs={4} md={4} l={4} className="product-image-col">
                      <Image src={product.image} alt={product.Name} className="product-image" />
                    </Col>
                    <Col xs={8} md={8} l={8} className="product-info">
                      <h5 className="product-title">{product.Name}</h5>
                      <p className="product-size-color">Adet: {product.Count}</p>
                      <p className="product-size-color-price">Fiyat: {formatCurrency(product.BasePrice)}</p>
                    </Col>
                  </Row>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
        </Row>

    {/* İade Özeti */}
    <Row className="w-100 justify-content-center">
          <Col md={6} >
            <Card className="mt-2 summary-card w-100">
              <Card.Header className='summary-header'>İade Özeti</Card.Header>
              <Card.Body style={{width:'100%'}}>
                <Row>
                  <Col xs={6} md={6} className="summary-title">
                    Ürün Adedi:
                  </Col>
                  <Col xs={6} md={6} className="summary-value">
                    {totalProducts}
                  </Col>
                </Row>
                <Row>
                  <Col xs={6} md={6} className="summary-title">
                    İade Tutarı:
                  </Col>
                  <Col xs={6} md={6} className="summary-value">
                    {formatCurrency(totalAmount)}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>


    <Row className="w-100 justify-content-center">
      <Col  md={6}>
         <Button className='mt-3 w-100 transparent-black-button' onClick={handleClick}>onayla</Button>
      </Col>
    </Row>
  </Container>
</>

  );
};

export default InvoiceProduct;
